import { offlineQueue } from './offline-queue';

const clearAllCookies = (): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const cookiePairs = document.cookie.split(';');
  for (const cookie of cookiePairs) {
    const separatorIndex = cookie.indexOf('=');
    const name = separatorIndex > -1 ? cookie.slice(0, separatorIndex).trim() : cookie.trim();
    if (!name) {
      continue;
    }

    const expired = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
    const hostname = window.location.hostname;
    const paths = ['/', window.location.pathname];

    for (const path of paths) {
      document.cookie = `${name}=;${expired};path=${path}`;
      document.cookie = `${name}=;${expired};path=${path};domain=${hostname}`;
      if (hostname.includes('.')) {
        document.cookie = `${name}=;${expired};path=${path};domain=.${hostname}`;
      }
    }
  }
};

const clearAllIndexedDB = async (): Promise<void> => {
  if (typeof indexedDB === 'undefined' || !indexedDB.databases) {
    return;
  }

  const databases = await indexedDB.databases();
  await Promise.all(
    databases.map(
      (database) =>
        new Promise<void>((resolve) => {
          if (!database.name) {
            resolve();
            return;
          }

          const request = indexedDB.deleteDatabase(database.name);
          request.onsuccess = () => resolve();
          request.onerror = () => resolve();
          request.onblocked = () => resolve();
        }),
    ),
  );
};

export const clearClientStorageOnLogout = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    offlineQueue.clearQueue();
  } catch (error) {
    console.error('[Logout] Error clearing offline queue:', error);
  }

  try {
    localStorage.clear();
  } catch (error) {
    console.error('[Logout] Error clearing localStorage:', error);
  }

  try {
    sessionStorage.clear();
  } catch (error) {
    console.error('[Logout] Error clearing sessionStorage:', error);
  }

  try {
    clearAllCookies();
  } catch (error) {
    console.error('[Logout] Error clearing cookies:', error);
  }

  void clearAllIndexedDB().catch((error) => {
    console.error('[Logout] Error clearing IndexedDB:', error);
  });
};
